import {
  FETCH_EXPENSES_PREPAID,
  FETCH_EXPENSES_PREPAID_SUCCESS,
  FETCH_EXPENSES_PREPAID_ERROR,
} from './constants';

export const prepaidInitialState = {
  isFetching: true,
  isEmpty: true,
  error: null,
  structure: [],
};

const filter = (data, filterType) => {
  if (filterType === 'expensesPrepaid') {
    const balanceDropdownMap = {};
    const numberDropdownMap = {};
    const smsDropdownMap = {};

    balanceDropdownMap.empty = 'Все балансы';
    numberDropdownMap.empty = 'Все звонки';
    smsDropdownMap.empty = 'Все сообщения';

    data.forEach((entry) => {
      const id = entry.balances[0].nameCode;
      const { filterId } = entry;

      balanceDropdownMap[id] = entry.balances[0].balanceText;
      numberDropdownMap[filterId] = entry.otherName;
      smsDropdownMap[filterId] = entry.otherName;
    });

    return { data, dropdown: { balance: balanceDropdownMap, call: numberDropdownMap, sms: smsDropdownMap } };
  }
};

const expensesPrepaid = (state = prepaidInitialState, action) => {
  switch (action.type) {
    case FETCH_EXPENSES_PREPAID:
      return {
        isFetching: true,
        error: action.error,
      };
    case FETCH_EXPENSES_PREPAID_ERROR:
      return {
        ...state.expensesPrepaid,
        isFetching: false,
        error: true,
      };
    case FETCH_EXPENSES_PREPAID_SUCCESS:
      return {
        ...state.expensesPrepaid,
        isFetching: false,
        isEmpty: false,
        error: null,
        structure: filter(action.data, 'expensesPrepaid'),
      };
    default:
      return state;
  }
};

export default expensesPrepaid;
